import * as _ from "lodash";
import { DashboardWidgetFilter } from "./dashboard-widget-filter.model";
import { DashboardWidgetStyle } from "./dashboard-widget-style.model";
import { ActivityFilter } from "./activity-filter.model";

export class DashboardWidget {
    public id: number | string = null;
    public name: string = null;
    public type: string = null;
    public datatype: string = null;
    public dashboardid: number = null;
    public width: number = null;
    public height: number = null;
    public x_pos: number = null;
    public y_pos: number = null;
    public cfid: number = null;
    public filter: DashboardWidgetFilter;
    public style: DashboardWidgetStyle;
    public status: string = null;
    public overtime: number = 0;
    public groupby: string | null = null;
    public columnsField: string | null = null;
    public rowsField: string | null = null;
    public saved: boolean = false;
    public hide: boolean = false;
    public timestamp: any = null;
    public creationtimestamp: any = null;
    public lastmodifiedtimestamp: any = null;
    public creator: number = null;
    public lastupdater: number = null;
    public hasEditPermission: boolean = false;

    constructor(data?: any) {
        this.setData(data);
        if (data) {
            if (this.type == "activity") {
                this.filter.dataTypeSpecificFilter = new ActivityFilter(
                    this.filter.dataTypeSpecificFilter
                );
            }
            if (this.datatype == "fields") {
                if (this.groupby) {
                    let dataFields = this.groupby.split(",");
                    this.columnsField = dataFields[0].trim();
                    if (dataFields.length > 1) {
                        this.rowsField = dataFields[1].trim();
                    }
                }
                this.style.tableType = "pivot";
            } else if (this.type == "table") {
                this.style.tableType = "standard";
            }
        }
    }

    setData(data: any): void {
        _.merge(this, data);
        this.overtime = Number(this.overtime) || 0;

        if (data && data.filter && typeof data.filter == "object") {
            //already an object, do nothing
        } else {
            this.filter = new DashboardWidgetFilter(
                data && data.filter ? JSON.parse(data.filter) : null
            );
        }

        if (data && data.style && typeof data.style == "object") {
            this.style.setData(data.style);
        } else {
            this.style = new DashboardWidgetStyle(
                data && data.style ? JSON.parse(data.style) : null
            );
        }
    }

    canStyle(): boolean {
        return (
            this.type == "stats" ||
            this.type == "chart" ||
            (this.type == "table" && this.datatype != "user_performance")
        );
    }
}
